module.exports = __webpack_public_path__ + "img/montenegro.575753f9.svg";